import { Navigate } from "react-router";
import { getCurrentRole } from "../lib/auth";
import { ROLE_LABEL_LO } from "../lib/roles";
import { TIER_HOME, tierOf } from "../lib/tier";
import { AccessDeniedPage } from "../components/RequireTier";

/**
 * `/` พาไปหน้าแรกของระดับที่ผู้ใช้อยู่ — ไม่มีหน้าแรกกลางที่ทุกระดับใช้ร่วมกัน
 * เพราะสิ่งที่การเงินเมือง/กวดกาแขวง/ผู้ดูแลระบบ ต้องเห็นก่อนเป็นคนละเรื่องกัน
 */
export function HomeRedirect() {
  const role = getCurrentRole();
  const tier = tierOf(role);
  if (tier) return <Navigate to={TIER_HOME[tier]} replace />;
  // ประชาชนล็อกอินเข้ามาได้ (token ถูกต้อง) แต่ไม่มีจอไหนให้ดู — ต้องบอกเหตุผล
  return <AccessDeniedPage required="district" roleLabel={role ? ROLE_LABEL_LO[role] : null} />;
}
